(() => {
  const selector = 'maoni-set-configurator[data-maoni-wildleder-set-filter]';

  const normalize = (value = '') => String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');

  const includedSetLabel = (configurator, variant) => {
    const position = Number(configurator.dataset.maoniSetOptionPosition || 0);
    if (!variant || position < 1) return '';

    if (Array.isArray(variant.options)) return variant.options[position - 1] || '';
    return variant[`option${position}`] || '';
  };

  const applyIncludedStrapFilter = (configurator, variant) => {
    const selectedSetLabel = normalize(includedSetLabel(configurator, variant));
    let selectionChanged = false;

    configurator.querySelectorAll('[data-maoni-set-exclusion-label]').forEach((card) => {
      const exclusionLabel = normalize(card.dataset.maoniSetExclusionLabel || '');
      const shouldHide = Boolean(selectedSetLabel && exclusionLabel && selectedSetLabel === exclusionLabel);
      const input = card.querySelector('input[data-maoni-accessory="strap"]');

      card.hidden = shouldHide;
      if (!input) return;

      input.disabled = shouldHide;
      if (shouldHide && input.checked) {
        input.checked = false;
        selectionChanged = true;
      }
    });

    if (selectionChanged) {
      const remainingSelection = configurator.querySelector('input[data-maoni-accessory="strap"]:checked');
      const noAccessory = configurator.querySelector('input[data-maoni-no-accessory="strap"]');
      if (!remainingSelection && noAccessory) noAccessory.checked = true;
    }

    if (typeof configurator.positionWalletCards === 'function') configurator.positionWalletCards();
    if (typeof configurator.updateSummary === 'function') configurator.updateSummary();
  };

  const init = (configurator) => {
    if (!configurator || configurator.dataset.maoniWildlederSetInitialized === 'true') return;
    configurator.dataset.maoniWildlederSetInitialized = 'true';

    const productRoot = configurator.closest('product-form');
    productRoot?.addEventListener('on:variant:change', (event) => {
      if (event.detail?.variant) applyIncludedStrapFilter(configurator, event.detail.variant);
    });

    applyIncludedStrapFilter(configurator, configurator.currentBagVariant || null);
  };

  customElements.whenDefined('maoni-set-configurator').then(() => {
    document.querySelectorAll(selector).forEach(init);
  });
})();
